import { Roles } from "./Roles";

export const currency = ["MYR", "USD", "SGD", "EUR"];

export const MENUITEMS = {
  HOME: "Home",
  USER_MANAGEMENT: "User Management",
  MAGP_USER_MANAGEMENT: "MAGP User Management",
  MAGP_ACCESS_MANAGEMENT: "MAGP Access Management",
  MAGP_HOME: "Popup",
  MAGP_ANNOUNCEMENT: "Announcements",
  MAGP_MANUAL: "Manual",
  MAGP_OTHERS: "Others",
  MAGP_FAQ: "FAQs",
  MAGP_APPROVAL_MANAGEMENT: "Approval Management",
  MAGP_LOGIN: "Login",
  MAGP_PROFILE: "Profile",
  MAGP_STATUS_INFORMATION: "Status Information",
  CORP_MEDIA_CENTRE: "Media Center",
  CORP_CORP_INTEGRITY: "Corporate Integrity",
  CORP_CORP_PROFILE: "Corporate Profile",
  CORP_SUBSIDIARIES: "Subsidiaries",
  CORP_AWARDS: "Awards",
  CORP_ORGANIZATION: "Organization",
  CORP_NAVIGATION: "Navigation",
  CORP_STAKEHOLDERS: "Stake Holders",
  CORP_BUSINESS_OPPURUTNITES: "Business Opportunities",
  CORP_MALAYSIA_AIRPORT_ACADMEY: "Malaysia Airport Academy",
  CORP_SUSTAINBILITY: "Sustainbility",
  CORP_CONTACT_US: "Contact us",
  CORP_HOMEPAGE: "Homepage",
  ERAMAN_DASHBOARD: "Dashboard",
  ERAMAN_PRODUCT_MANAGEMENT: "Product Management",
  ERAMAN_FORMS_SUBMISSIONS: "Feedback Submissions",
  ERAMAN_MEMBERS: "Newsletter Subscription",
  ERAMAN_USER_TRANSACTIONS: "EPC Applications",
  ERAMAN_ADVERTISEMENT: "Advertisement",
  ERAMAN_PAGES: "Pages",
  ERAMAN_HEADER: "Header",
  ERAMAN_FOOTER: "Footer",
  ERAMAN_CONFIGURATION: "Configuration",
  ERAMAN_PRODUCTREVIEWS: "Product Reviews",
  PASSENGER_BUTTERFLYEFFECT: "Butterfly Effect",

  PASSENGER_MAPS: "Maps",
  PASSENGER_HELP: "Help",
  PASSENGER_SHOP_DINE: "Shop & Dine",
  PASSENGER_USER_MANAGEMENT: "Passenger User Management",
  PASSENGER_HOMEPAGE: "Passenger Homepage",
  PASSENGER_MOBILE_APP: "Mobile App",
  PASSENGER_FOOTER: "Footer",
  PASSENGER_HEADER: "Header",
  PASSENGER_FLIGHT_INFORMATION: "Flight Information",
  PAGE_HEADER_MENU: "PageHeader",
  PASSENGER_NAVIGATION: "Navigation",

  MAGP_DASHBOARD: "Dashboard",
  ERAMAN_USER_MANAGEMENT: "Eraman User Management",
  CORP_TRAINING_ACADEMY: "Malaysia Airport Academy",
  MAGP_GALLERY: "Gallery",
  MAGP_CONTRACT_DIRECTORY: "Contact Directory",
  ERAMAN_CONTENTS: "Contents",
  ERAMAN_STORE_LOCATIONS: "Store Locations",

  //CENTRALIZED
  CENTRALIZED_MODULES: "Modules",
  CENTRALIZED_BANNER: "Banner",
  CENTRALIZED_PRIVACY_POLICY: "Policies",
  CENTRALIZED_FAQS: "FAQs",
  CENTRALIZED_AIRLINE_IMAGES: "Airline Tail Image",
  CENTRALIZED_TRAVELLERS_INFO: "Traveller's Info",
  CENTRALIZED_STATUS_INFORMATION: "Status Information",
  CENTRALIZED_PROMOTIONS: "Promotions",
  CENTRALIZED_APPROVAL_MANAGEMENT: "Approval Management",
  CENTRALIZED_USER_MANAGEMENT: "Centralized User Management",
  CENTRALIZED_SHOP_DINE: "Shop & Dine",
  CENTRALIZED_LAGS_RESTRICTED_ITEMS: "Lags & Restricted Items",
  CENTRALIZED_BAGGAGE_GUIDE: "Baggage Guide",
  CENTRALIZED_MYAIRPORTS_PROMOTIONS: "MyAirports Promotions",
};

export const defaultRedirectURL = (type: string) => {
  let ret = "/ecms/welcome-page";
  let obj: any = {
    MAGP_CREATOR: "/dedicated/magp/dashboard",
    MAGP_REVIEWER: "/dedicated/magp/dashboard",
    SUPER_ADMIN: `/dedicated/magp/approval-management`,
    WELCOME_PAGE: "/ecms/welcome-page",
    MODULE_SELECTION: "/auth/ecms",
    PASSENGER_ECMS_CREATOR: "/dedicated/passenger/homepage?activeTab=sliders",
    PASSENGER_ECMS_REVIEWER: "/dedicated/passenger/approval-management?activeTab=pending",

    PASSENGER_CREATOR: "/dedicated/passenger/butterfly-effect",
    PASSENGER_REVIEWER: "/dedicated/passenger/butterfly-effect",

    ERAMAN_CREATOR: "/dedicated/eraman/dashboard",
    ERAMAN_REVIEWER: "/dedicated/eraman/approval-management",
    MAHB_CORPORATE_CREATOR: "/dedicated/corporate/homepage",
    MAHB_CORPORATE_REVIEWER: "/dedicated/corporate/approval-management?activeTab=pending",
    CENTRALIZED_CREATOR: "/centralized/centralizedBanner",
    CENTRALIZED_REVIEWER: "/centralized/approval-management",
  };
  if (obj[type]) return obj[type];
  return ret;
};

// export const getCurrentModule = () => {
//   const user = JSON.parse(localStorage.getItem("user") || "{}");
//   let ret = "";
//   if (user.role === Roles.SUPER_ADMIN) {
//     ret = JSON.parse(localStorage.getItem("currentModule"));
//   } else if (user.role) {
//     // ret = user.role.split("_")[0];
//     if (user.role === "MAHB_CORPORATE_CREATOR" || user.role === "MAHB_CORPORATE_REVIEWER") {
//       ret = "CORPORATE";
//     } else {
//       ret = user.role.split("_")[0];
//     }
//   }
//   return ret;
// };

export const getCurrentModule = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const currentModule = localStorage.getItem("currentModule");
  let ret = "";

  // First check if there's a currentModule in localStorage
  if (currentModule) {
    ret = JSON.parse(currentModule);
  } else if (user.role) {
    if (user.role === Roles.MAHB_CORPORATE_CREATOR || user.role === Roles.MAHB_CORPORATE_REVIEWER) {
      ret = "CORPORATE";
    } else if (user.role.startsWith("PASSENGER_ECMS")) {
      ret = "PASSENGER ECMS";
    } else if (user.role.startsWith("PASSENGER")) {
      ret = "PASSENGER BUTTERFLY EFFECT";
    } else {
      ret = user.role.split("_")[0];
    }
  }

  return ret;
};

export const getModulePath = (module: string) => {
  if (module === "PASSENGER ECMS" || module === "PASSENGER BUTTERFLY EFFECT") {
    return "passenger";
  }
  return module?.toLowerCase();
};

export enum ModuleType {
  PCD_USER = "pcd",
  COMMERCIAL_USER = "commercial",
  CMU_CREATOR = "CMU",
  CMU_REVIEWER = "CMU",
  LOO_CREATOR = "LOO",
  LOO_REVIEWER = "LOO",
  TA_REVIEWER = "TA",
  CLM_USERS = "clm",
  LOA_CREATOR = "LOA",
  LOA_REVIEWER = "LOA",
  CONTRACT_CREATOR = "Contracts",
  CONTRACT_REVIEWER = "Contracts",
  PCD_ADMIN = "pcd",
  COMMERCIAL_ADMIN = "commercial",
  SUPER_ADMIN = "clm",
  LEGAL_USER = "legal",
  LEGAL_ADMIN = "legal",
}

export const timezone = "Asia/Kuala_Lumpur";
